import { NavigateOptions, To, useNavigate } from 'react-router-dom';

import { useBreadcrumbs } from '~/stores/use-breadcrumbs/useBreadcrumbs';

export type NavigateTerminalProps = {
  to?: To;
  options?: NavigateOptions;
  navigateFn?: () => void;
  crumb?: {
    label: string;
    isSidebar?: boolean;
    isAccessibleFromSideBar?: boolean;
    themeId?: string;
    assetTag?: string;
  };
};

export const useTerminalNavigate = () => {
  const navigate = useNavigate();
  const { handleLocationChange } = useBreadcrumbs(state => ({
    handleLocationChange: state.handleLocationChange,
  }));

  const navigateTerminal = ({
    to,
    navigateFn,
    crumb,
  }: NavigateTerminalProps) => {
    handleLocationChange({ to, crumb, navigateFn });

    to ? navigate(to) : navigateFn?.();
  };

  return navigateTerminal;
};
